
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import ApiButton from "@/vue/components/ApiButton.vue";
import ApiClient from "@/utilities/ApiClient";
import FileDownload from "@/utilities/FileDownload";
import { Resource } from '@/model/Resource';
import { IFileUploadResponse } from "@/model/IFileUploadResponse";
import * as toastr from "toastr";
import Utils from "@/utilities/Utils";

@Component({
    components: { ApiButton }
})
export default class FileUpload extends Vue {

    chosenFile: File|null = null;

    isUploading: boolean = false;

    @Prop({ required: true }) resource!: Resource;
    @Prop({ required: true }) label!: string;
    @Prop({ default: "" }) accept!: string;
    @Prop({ default: false }) capture!: string|boolean;
    @Prop({ default: () => [] }) rules!: Array<(() => string | boolean) | ((v: any) => string | true)>;
    @Prop({ default: 0 }) maxFileSize!: number;
    @Prop({ default: false }) isPublicUpload!: boolean; // public has progressive delay to help with DoS attacks

    //mounted(): void { }

    get rulesPlus(): Array<(() => string | boolean) | ((v: any) => string | true)> {
        if (this.maxFileSize == 0) return this.rules;
        const maxSizeValidator = (v: any) => v != null && v.size < this.maxFileSize || `File must be smaller than ${Utils.fileSize(this.maxFileSize)}`
        return [...this.rules, maxSizeValidator]; // clone + add one more for max file size
    }

    // get iconUrl(): string {
    //     if(!this.resource.hasFile) return ApiClient.resolveUrl("api/file/icon?extension=nul");
    //     const filename = this.resource.filename;
    //     const dotAt = filename.lastIndexOf(".");
    //     const extension = dotAt === -1 || dotAt >= filename.length - 1 ? "" : filename.substr(dotAt + 1).toLowerCase();
    //     return ApiClient.resolveUrl(`api/file/icon?extension=${extension}`);
    // }

    async onChange(file: File|null): Promise<void> {
        this.chosenFile = file;
        console.log("onInput ", file);
        if(file == null) return;
        //const fileInput: any = this.$refs.fileInput;
        //fileInput.loading = true;
        await this.uploadFile(file);
    }

    async onFileDropped(event: any): Promise<void> {
        const file = event?.dataTransfer?.files[0]
        if(!file) return;
        await this.uploadFile(file);
    }

    async uploadFile(file: File): Promise<void> {
        const formData = new FormData();
        formData.append("formFile", file);
        //formData.append("someID", "666");
        this.isUploading = true;
        try {
            const path = this.isPublicUpload ? "/api/file/uploadPublic" : "/api/file/upload";
            const response: IFileUploadResponse = await ApiClient.postNonJson(path, formData);
            this.resource.httpContentType = response.httpContentType;
            this.resource.originalFilename = response.originalFilename;
            this.resource.filename = response.filename;
            this.resource.size = response.size;
            this.isUploading = false;
            this.$emit("uploaded", this.resource);
        } catch (error) {
            this.isUploading = false;
            toastr.error("Upload failed");
        }
    }

    @Watch("chosenFile", { immediate: false, deep: true })
    async onChosenFilechanged(): Promise<void> {
        console.log("onChosenFileChanged ", this.chosenFile);
    }

    async clear(): Promise<void> {
        this.chosenFile = null;
        Utils.resetObject(this.resource);
    }

    async download(): Promise<void> {
        FileDownload.download(this.resource);
    }
}
